import React from 'react';
import PropTypes from 'prop-types';

import { Box as MUIBox } from '@mui/material';

// v9 removed Box's own system props (display/alignItems/justifyContent/flexDirection/m etc as
// direct props) entirely — only `sx` still works. Translated internally here so this wrapper's
// own external API (what the 2 real consumers already use) doesn't need to change.
export const Box = ({
  alignItems,
  display,
  flexDirection,
  justifyContent,
  m: margin,
  sx,
  ...props
}) => (
  <MUIBox
    {...props}
    sx={{
      ...(typeof display !== 'undefined' && { display }),
      ...(typeof alignItems !== 'undefined' && { alignItems }),
      ...(typeof justifyContent !== 'undefined' && { justifyContent }),
      ...(typeof flexDirection !== 'undefined' && { flexDirection }),
      ...(typeof margin !== 'undefined' && { m: margin }),  // eslint-disable-line id-length
      ...sx
    }}
  />
);

Box.propTypes = {
  alignItems: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  display: PropTypes.string,
  flexDirection: PropTypes.string,
  justifyContent: PropTypes.string,
  m: PropTypes.number,  // eslint-disable-line id-length
  sx: PropTypes.object
};

export default Box;
